import CodeIcon from '@material-ui/icons/Code';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import PeopleIcon from '@material-ui/icons/People';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import RouteIcon from '@material-ui/icons/LocationSearchingRounded';
import RouteMasterIcon from '@material-ui/icons/LocationOn';
import DepartureBoard from '@material-ui/icons/DepartureBoard';
import BirdViewIcon from '@material-ui/icons/DonutSmall';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';

const pagesArray = [
  {
    title: 'Pages',
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: ViewQuiltIcon,
        id: 1
      },
      {
        title: 'Bird View',
        href: '/bird-view',
        icon: BirdViewIcon,
        id: 12
      },
      // {
      //   title: 'Pick Up',
      //   href: '/pick-up',
      //   icon: BirdViewIcon,
      //   id: 12
      // },
      {
        title: 'Orders',
        href: '/management/orders',
        icon: CardTravelIcon,
        id: 2
      },
      {
        title: 'Assign Captain',
        href: '/captains/assigned',
        icon: LocalShippingIcon,
        id: 3
      },
      {
        title: 'Tracking',
        href: '/management/tracking',
        icon: LocationOnIcon,
        id: 4
      },
      {
        title: 'Manifests',
        href: '/management/manifests',
        icon: AssignmentIcon,
        id: 5
      },
      {
        title: 'Audit Dashboard',
        href: '/audit/dashboard',
        icon: DashboardIcon,
        id: 6
      },
      {
        title: 'File Upload',
        href: '/upload/file',
        icon: CodeIcon,
        id: 7
      },
      {
        title: 'Route Planning',
        href: '/management/routePlanning',
        icon: RouteIcon,
        id: 8
      },
      {
        title: 'Route Master',
        href: '/management/routeMaster',
        icon: RouteMasterIcon,
        id: 9
      },
      {
        title: 'Delivery Performance',
        href: '/management/deliveryPerformance',
        icon: DepartureBoard,
        id: 10
      }
    ]
  }
];

export default pagesArray;
